import { toCurrency } from 'scenes/common/helpers/currency';
import { GovernmentCharges, Premium } from 'scenes/common/types';
import { WirePremium, WirePremiumFrequencies } from '../types';

export const findPremium = (premiums: WirePremium[], refIds?: string[]) => {
  const filteredPremiums = premiums.filter((p) => refIds?.includes(p.id));
  if (filteredPremiums.length === 0) {
    throw new Error('No premiums returned');
  }

  const yearly = filteredPremiums.filter(
    (p) => p.frequency === WirePremiumFrequencies.Yearly
  )[0];
  const monthly = filteredPremiums.filter(
    (p) => p.frequency === WirePremiumFrequencies.Monthly
  )[0];

  return { yearly, monthly };
};

const toGovernmentCharges = (premium: WirePremium): GovernmentCharges => ({
  gst: premium.gst,
  fireServicesLevy: premium.fsl,
  stampDuty: premium.sd,
});

export const toPremium = ({
  monthly,
  yearly,
}: {
  monthly: WirePremium;
  yearly: WirePremium;
}): Premium => ({
  price: toCurrency(monthly.gross),
  firstInstalment: toCurrency(monthly.instalment || 0),
  monthlyInstalment: toCurrency(monthly.instalment || 0),
  annualPrice: toCurrency(yearly.gross),
  monthlyGovernmentCharges: toGovernmentCharges(monthly),
  yearlyGovernmentCharges: toGovernmentCharges(yearly),
});
